module.exports = __webpack_public_path__ + "img/route_1_s.df247c24.png";